module.exports = __webpack_public_path__ + "img/tree_layer_5_deco_2.4f32e8fa.png";